import { render } from "./Releve.vue?vue&type=template&id=283b7249"
import script from "./Releve.vue?vue&type=script&lang=js"
export * from "./Releve.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__